interface CardDisplayProps {
  card: { rank: string; suit: string } | null
  hidden?: boolean
}

const SUIT_SYMBOLS: Record<string, string> = {
  s: '♠',
  h: '♥',
  d: '♦',
  c: '♣',
}

const RED_SUITS = ['h', 'd']

function displayRank(rank: string): string {
  return rank === 'T' ? '10' : rank
}

export function CardDisplay({ card, hidden = false }: CardDisplayProps) {
  if (!card || hidden) {
    return (
      <div
        className="poker-card back animate-deal"
        style={{ width: '56px', height: '80px' }}
      >
        <span className="back-label-top">X8</span>
        <span className="back-label-bottom">Poker</span>
      </div>
    )
  }

  const isRed = RED_SUITS.includes(card.suit)

  return (
    <div
      className={`poker-card ${isRed ? 'red' : 'black'} animate-deal`}
      style={{ width: '56px', height: '80px' }}
    >
      <div className="text-base font-extrabold leading-none">{displayRank(card.rank)}</div>
      <div className="text-lg leading-none mt-0.5">{SUIT_SYMBOLS[card.suit]}</div>
    </div>
  )
}
